<template>
    <div>
        <!-- PRIMARY -->
        <template v-if="type==='primary'">
            <div class="primary">
                <!-- Normal -->
                <template v-if="severity==='normal'">
                    <Button :label="label" :icon="iconClass" style="background-image: linear-gradient(var(--button-normal-color-g), var(--button-normal-color)); border: 1px solid var(--button-normal-color); color: var(--button-primary-font-color);" @click="emit('click')" :disabled="disabled"/>
                </template>
                <!-- Danger -->
                <template v-if="severity==='danger'">
                    <Button :label="label" :icon="iconClass" style="background-image: linear-gradient(var(--button-danger-color-g), var(--button-danger-color)); border: 1px solid var(--button-danger-color); color: var(--button-primary-font-color);" @click="emit('click')" :disabled="disabled"/>
                </template>
            </div>
        </template>

        <!-- SECONDARY -->
        <template v-if="type==='secondary'">
            <!-- Normal -->
            <template v-if="severity==='normal'">
                <Button outlined :label="label" :icon="iconClass" style="color: var(--button-normal-color)" @click="emit('click')" :disabled="disabled"/>
            </template>
            <!-- Danger -->
            <template v-if="severity==='danger'">
                <Button outlined :label="label" :icon="iconClass" style="color: var(--button-danger-color)" @click="emit('click')" :disabled="disabled"/>
            </template>
        </template>

        <!-- TEXT -->
        <template v-if="type==='text'">
            <div class="text-button">
                <!-- Normal -->
                <template v-if="severity==='normal'">
                    <Button text style="color: var(--button-normal-color);" @click="emit('click')" :disabled="disabled">
                        <div class="w-full flex justify-content-center">
                            <div class="flex flex-row justify-content-center align-items-center gap-2">
                                <i v-if="iconClass" class="p-button-label" :class="iconClass"/>
                                <span v-if="label" class="p-button-label">{{ label }}</span>
                            </div>
                        </div>
                    </Button>
                </template>
                <!-- Danger -->
                <template v-if="severity==='danger'">
                    <Button text style="color: var(--button-danger-color)" @click="emit('click')" :disabled="disabled">
                        <div class="w-full flex justify-content-center">
                            <div class="flex flex-row justify-content-center align-items-center gap-2">
                                <i v-if="iconClass" class="p-button-label" :class="iconClass"/>
                                <span v-if="label" class="p-button-label">{{ label }}</span>
                            </div>
                        </div>
                    </Button>
                </template>
            </div>
        </template>

        <!-- ICON -->
        <template v-if="type==='icon'">
                <div class="icon-button">
                <!-- Normal -->
                <template v-if="severity==='normal'">
                    <Button text :icon="iconClass" rounded style="color: var(--button-normal-color)" @click="emit('click')" :disabled="disabled"/>
                </template>
                <!-- Danger -->
                <template v-if="severity==='danger'">
                    <Button text :icon="iconClass" rounded style="color: var(--button-danger-color)" @click="emit('click')" :disabled="disabled"/>
                </template>
            </div>
        </template>
    </div>
</template>

<script setup>
// --- IMPORTS ---
// PrimeVue
import Button from "primevue/button"

// --- PROPS ---
const props = defineProps({
    type: String, // type : primary, secondary, text
    severity: String, // severity : normal, danger
    label: String,
    iconClass: String,
    disabled: Boolean,
})

// --- EMITS ---
const emit = defineEmits(['click'])
</script>

<style scoped>
.p-button:not(.text-button .p-button):not(.icon-button .p-button) {
    min-width: var(--button-min-width);
}
.primary :deep(.p-button-label) {
    font-weight: var(--button-primary-font-weight);
}
</style>